import React, { useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserInformation } from "../../store/slices/userSlice";
import { RootStateType } from "../../store/RootState";
import { ThunkDispatch } from "redux-thunk";
import { Button } from "../components/Elements";
import { ResetPasswordModal } from "../components";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";

const UserProfile = () => {

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const resetPasswordModalRef = useRef<any>();

    const { userInformations, } = useSelector((state: RootStateType) => state.user);

    useLayoutEffect(() => {

        dispatch(getUserInformation());
    }, []);

    const changePasswordClick = () => {

        resetPasswordModalRef.current.openModal();
    }

    return (
        <div className="w-full">
            <PageTitle title={pageTitleTexts.userProfile} />
            <ResetPasswordModal ref={resetPasswordModalRef} />
            {/* <div className="px-4 py-2 flex flex-col justify-start space-y-2">
                <div className="flex flex-row items-center">
                    <img src={"/icons/person-dark.svg"} className="h-6 w-6 black" />
                    <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                        Kullanıcı Bilgileri
                    </span>
                </div>
                <div className="px-4 py-2 bg-white shadow-md flex justify-center rounded-md">
                    <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 pb-3">
                        <div className="flex flex-col justify-start px-0">
                            <div className="mt-3">
                                <div className="basis-5/12 text-black font-bold max-w-[140px]">Kullanıcı Adı: </div>
                                <div className="basis-7/12 w-min text-left min-w-[140px]">{userInformations.userName ? userInformations.userName : "-"} </div>
                            </div>
                            <div className="mt-3">
                                <div className="basis-5/12 text-black font-bold max-w-[140px]">Kullanıcı Kodu: </div>
                                <div className="basis-7/12 w-min text-left min-w-[140px]">{userInformations.userCode ? userInformations.userCode : "-"}</div>
                            </div>
                        </div>
                        <div className="flex flex-col justify-start px-0">
                            <div className="mt-3">
                                <label className="basis-5/12 text-black font-bold max-w-[140px]">Kullanıcı Açıklaması: </label>
                                <div className="basis-7/12 w-min text-left min-w-[140px]">{userInformations.userDesc ? userInformations.userDesc : "-"}</div>
                            </div>
                            <div className="mt-3">
                                <div className="basis-5/12 text-black font-bold max-w-[140px]">Kullanıcı Telefon: </div>
                                <div className="basis-7/12 w-min text-left min-w-[140px]">{userInformations.userPhone ? userInformations.userPhone : "-"}</div>
                            </div>
                            <div className="mt-3">
                                <Button
                                    type="button"
                                    color="primary"
                                    hover="primary"
                                    size="xl"
                                    callback={changePasswordClick}
                                >
                                    Şifreyi Değiştir
                                </Button>
                            </div>
                        </div>
                        <div className="flex flex-col justify-start px-0">
                            <div className="mt-3">
                                <div className="basis-5/12 text-black font-bold max-w-[140px]">Kullanıcı Mail Adresi: </div>
                                <div className="basis-7/12 w-min text-left min-w-[140px]">{userInformations.userEmail ? userInformations.userEmail : "-"} </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="px-4 py-2 flex flex-col items-center space-y-2">
                <div className="flex flex-row items-center w-[1000px]">
                    <img src={"/icons/person-dark.svg"} className="h-6 w-6 black" />
                    <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                        Kullanıcı Bilgileri
                    </span>
                </div>
                <div className="w-full flex justify-center  min-w[1000px]">
                    <div className="px-4 pb-4 pt-8 bg-white shadow-md flex flex-col pl-20 rounded-md w-[1000px]">
                        <div className="w-[500px] flex flex-col">
                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                <div className="mt-3">
                                    <div className="basis-5/12 text-black font-bold">Kullanıcı Adı: </div>
                                </div>
                                <div className="mt-3">
                                    <div className="basis-7/12 text-left">{userInformations.userName ? userInformations.userName : "-"}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                <div className="mt-3">
                                    <div className="basis-5/12 text-black font-bold">Kullanıcı Kodu: </div>
                                </div>
                                <div className="mt-3">
                                    <div className="basis-7/12 text-left">{userInformations.userCode ? userInformations.userCode : "-"}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                <div className="mt-3">
                                    <label className="basis-5/12 text-black font-bold">Kullanıcı Açıklaması: </label>
                                </div>
                                <div className="mt-3">
                                    <div className="basis-7/12 text-left">{userInformations.userDesc ? userInformations.userDesc : "-"}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                <div className="mt-3">
                                    <div className="basis-5/12 text-black font-bold">Kullanıcı Telefon: </div>
                                </div>
                                <div className="mt-3">
                                    <div className="basis-7/12 text-left">{userInformations.userPhone ? userInformations.userPhone : "-"}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                                <div className="mt-3">
                                    <div className="basis-5/12 text-black font-bold">Kullanıcı Mail Adresi: </div>
                                </div>
                                <div className="mt-3">
                                    <div className="basis-7/12 text-left">{userInformations.userEmail ? userInformations.userEmail : "-"} </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex justify-center">
                            <div className="mt-5">
                                <Button
                                    type="button"
                                    color="primary"
                                    hover="primary"
                                    size="xl"
                                    callback={changePasswordClick}
                                >
                                    Şifreyi Değiştir
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default UserProfile;